import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function ScopePill({ workspace, snapshotId, expanded, onClick, onKeyDown, locked, }) {
    const isLocked = locked ?? !onClick;
    return (_jsxs("button", { type: "button", "data-scope-pill": true, "aria-haspopup": isLocked ? undefined : 'menu', "aria-expanded": isLocked ? undefined : expanded ? 'true' : 'false', "aria-label": snapshotId
            ? `Assessor scope — ${typeof workspace === 'string' ? workspace : 'workspace'} snapshot ${snapshotId}`
            : 'Assessor scope', onClick: onClick, onKeyDown: onKeyDown, style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: 'var(--sp-2)',
            padding: '6px var(--sp-3)',
            background: 'var(--band-blue-bg)',
            border: '1px solid var(--band-blue-mark)',
            borderRadius: 'var(--radius-md)',
            color: 'var(--band-blue)',
            fontSize: 'var(--fs-sm)',
            fontWeight: 500,
            minHeight: 32,
            cursor: isLocked ? 'default' : 'pointer',
            fontFamily: 'inherit',
        }, children: [_jsx("span", { "aria-hidden": true, children: "\uD83D\uDD12" }), _jsxs("span", { children: [workspace, " \u00B7 snapshot"] }), !isLocked && (_jsx("span", { "aria-hidden": true, style: { color: 'var(--band-blue)', fontSize: 10 }, children: "\u25BE" }))] }));
}
//# sourceMappingURL=ScopePill.js.map